import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import star from "../Assets/imgs/star.webp";
import design from "../Assets/imgs/design360.webp";
import arrow from "../Assets/imgs/arrow.webp";
import { animatedStar } from "../utils/GSAPFunctions";
const Strategy = () => {
  const starRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (starRef.current) {
        animatedStar(starRef);
      }
    }, starRef);

    return () => ctx.revert(); // cleanup
  }, []);

  return (
    <>
      <div className="__StrategySection">
        <div className="container-fluid">
          <div className="row __rowReverse">
            <div className="col-lg-5 col-md-12 col-12">
              <div className="__leftCol">
                <div className="__blueHeading">
                  From Strategy
                  <br /> to Scale:
                  <br /> A Complete GTM
                  <br /> Transformation
                </div>
                <div className="__shortDesc">
                  Results from a Cybersecurity Company after 36
                  <br /> months of partnership with Be the Buzz
                </div>
                <div className="__profitCard">
                  <div className="__percProfit">
                    567 <span> %</span>
                  </div>
                  <div className="__shortDesc">
                    GROSS PROFIT
                    <br /> SURGE
                  </div>
                </div>
                <div className="__profitCard">
                  <div className="__percProfit">
                    500
                  </div>
                  <div className="__shortDesc">
                    Consecutive Inc. 500
                    <br /> spot holder
                  </div>
                </div>
                <div className="__profitCard">
                  <div className="__percProfit">
                    02
                  </div>
                  <div className="__shortDesc">
                    2nd Fastest-growing
                    <br /> company in California
                  </div>
                </div>
                <div className="__caseStudy">View Case Study</div>
                <div className="__bar"></div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12">
              <div className="__rightCol">
                <div className="col-lg-12 .col-md-12">
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="__animatedStar" ref={starRef}>
                        <img src={star} alt="star" id="animatedStar" />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div className="__designImg">
                        <img src={design} alt="design 360" />
                      </div>
                      <div className="__blueHeading">
                        Build Your Complete
                        <br /> Go-to-Market
                        <br /> Ecosystem
                      </div>
                    </div>
                  </div>
                  <div className="__shortDesc">
                    In a competitive market, success demands more than isolated
                    marketing efforts. We create comprehensive go-to-market
                    ecosystems that align every element of your growth
                    strategy—from positioning to execution. By integrating sales
                    and marketing into a unified system, we drive
                    partnership-led success focused on real business outcomes,
                    not vanity metrics. We don't just create buzz.
                  </div>
                  <div className="__defaultBtn">
                    <span className="__leftSvg">
                      <img src={arrow} alt="arrow" />
                    </span>
                    <div className="__rightSideArrow">
                      <p> Start Your GTM Assessment</p>
                      <span className="__rightSvg">
                        <img src={arrow} alt="arrow" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Strategy;
